import { Platform } from 'react-native';

/**
 * The soft coloured halo behind the round badge in the gamification celebration
 * modals (achievement unlocked, milestone reached).
 *
 * Why it needs a helper rather than a plain style: RN's `shadow*` props map to a
 * CSS `box-shadow` on web, which traces the element's BOX. The glow wrapper used
 * to be an unsized square carrying `shadowOpacity`/`shadowRadius` with the colour
 * applied on native only — so on web the badge came out as a round icon sitting
 * inside a visible grey rectangle, and the halo was black rather than the
 * achievement's colour. Web now gets an explicit round, coloured shadow; native
 * keeps `shadowColor` (iOS) plus `elevation` (Android, which ignores shadow*).
 *
 * Pair with a wrapper whose size and `borderRadius` match the badge, so the halo
 * has a circle to trace on either platform.
 */
export function glowFor(color: string): Record<string, unknown> {
  if (Platform.OS === 'web') {
    // `59` ≈ 35% alpha — present enough to read as a glow, soft enough not to
    // become a second ring around the badge's own border.
    return { boxShadow: `0 0 26px 6px ${color}59` };
  }
  return {
    shadowColor: color,
    shadowOpacity: 0.6,
    shadowRadius: 24,
    shadowOffset: { width: 0, height: 0 },
    elevation: 12,
  };
}
